import dateStringToUTCDate from './dateStringToUTCDate';
var parseCalendarDates = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, excludedDates = _a.excludedDates;
    return {
        startDate: dateStringToUTCDate(startDate),
        endDate: dateStringToUTCDate(endDate),
        excludedDates: excludedDates
            ? excludedDates.split(',').map(function (d) { return new Date(d); })
            : []
    };
};
export default parseCalendarDates;
//# sourceMappingURL=parseCalendarDates.js.map